// src/components/cookie-banner.js (JS or TS works)
import React from 'react';
import { CookieNotice } from 'gatsby-cookie-notice';

const CookieBanner = () => (
	<CookieNotice
		backgroundWrapperClasses='cookie-bg'
		backgroundClasses='cookie-inner background-white backdrop rounded-edges'
		wrapperClasses='cookie-container'
		buttonWrapperClasses='cookie-btn-wrapper'
		acceptButtonClasses='cookie-btn cookie-btn--accept'
		declineButtonClasses='cookie-btn cookie-btn--decline'
		personalizeButtonClasses='cookie-btn personalise-btn'
		personalizeValidationClasses='cookie-btn cookie-btn--accept'
		cookieMapClasses='cookie-item'
		personalizeButtonEnable={true}
		declineButton={false}
		acceptButtonText='Accept'
		declineButtonText='Decline'
		personalizeButtonText='Customise'
		cookieDays={365}
		cookies={[
			{
				name: 'necessary',
				editable: false,
				default: true,
				title: 'Strictly necessary',
				text: 'Required for the site to function.',
			},
			{
				name: 'gdpr-ga',
				editable: true,
				default: false,
				title: 'Analytics',
				text: 'Helps us understand site traffic (Google Analytics).',
			},
			{
				name: 'gdpr-fbp',
				editable: true,
				default: false,
				title: 'Marketing',
				text: 'Used for personalised ads (Meta Pixel).',
			},
		]}
	>
		<h2>Cookie Settings</h2>
		<p>
			For the best performance and experience, we use cookies on this
			website.
		</p>
	</CookieNotice>
);

export default CookieBanner;
